import _ from 'lodash'
import uuidv1 from 'uuid/v1'

export const applyUpdate = (fileList, updatingFile) => {
  const { uid: updatingId, response } = updatingFile
  const respTransFile = { ...updatingFile, url: response }
  const mergedFiles = _.merge(
    _.mapKeys(fileList, ({ uid }) => uid),
    { [updatingId]: respTransFile }
  )
  return _.map(mergedFiles)
}

export const getProductImages = images => {
  return _.filter(images, image => {
    const { width, height } = image
    return (
      width === height &&
      width >= 1000 &&
      height >= 1000
    )
  })
}

export const getErrors = (file = {}, listings = []) => {
  const {
    type = '',
    dimension: {
      width,
      height
    } = {}
  } = file
  const errors = []
  // 驗證 PNG
  if (type !== 'image/png') {
    errors.push(`圖片須為 PNG 格式：目前圖片為 ${_.toUpper(type.replace('image/', ''))}`)
  }

  // 驗證圖片是否為正方形
  if (width !== height) {
    errors.push(`圖片寬度與高度須相同：目前圖片為 ${width}x${height} px`)
  }

  // 驗證尺寸
  if (width < 1000) {
    errors.push(`圖片尺寸不可小於 1000px：目前圖片為 ${width}x${height} px`)
  }

  // 驗證批次賣場裡的圖片
  const imageErrors = _.reduce(listings, (collectErrors, listing) => {
    const {
      id: listingId,
      images = [],
      models = [],
      isNoModelsListing
    } = listing
    // 無屬性賣場沒有圖片
    if (isNoModelsListing && _.isEmpty(images)) {
      collectErrors.push(`賣場 ${listingId} 沒有圖片`)
    }

    const modelImagesList = _.map(models, model => _.get(model, 'images', []))
    // 無屬性賣場圖片超過 9 張
    const isModelListingHasExceedLimitImageCount = _.some(modelImagesList, modelImages => {
      return (_.size(getProductImages(modelImages)) > 9)
    })

    // 有屬性賣場沒有圖片
    const isModelListingHasNoImage = _.some(modelImagesList, modelImages => {
      return (_.size(modelImages) === 0)
    })
    // 有屬性賣場圖片超過 9 張
    const isNoModelListingHasExceedLimitImageCount = (
      isNoModelsListing &&
      (_.size(getProductImages(images)) > 9)
    )
    if (
      isModelListingHasExceedLimitImageCount ||
      isNoModelListingHasExceedLimitImageCount
    ) {
      collectErrors.push(`賣場 ${listingId} 圖片大於 9 張`)
    }

    if (isModelListingHasNoImage) {
      collectErrors.push(`賣場 ${listingId} 沒有圖片`)
    }

    const totalImages = _.concat(images, ...modelImagesList)
    // 有圖片還在上傳
    const isImageUploading = _.some([...totalImages], ({ url }) => {
      return _.isUndefined(url)
    })
    if (isImageUploading) {
      collectErrors.push(`賣場 ${listingId} 含有圖片狀態為上傳中`)
    }

    return collectErrors
  }, [])
  if (!_.isEmpty(imageErrors)) {
    errors.push(...imageErrors)
  }

  return errors
}

// 取得全部賣場首圖
export const getListingFirstImages = listings => {
  const listingFirstImages = _.reduce(listings, (collect, listing) => {
    const { models = [] } = listing
    const modelListingImageUrls = _.flow(
      () => _.map(models, model => _.get(model, 'images', [])),
      modelImagesList => _.concat(...modelImagesList),
      modelImages => _.filter(modelImages, { width: 1000, order: 1 }),
      firstModelImages => _.map(firstModelImages, 'url')
    )()
    collect.push(...modelListingImageUrls)
    return collect
  }, [])
  const uniqListingFirstImages = _.uniq(listingFirstImages)
  return uniqListingFirstImages
}

// 將首圖取代成合成圖並把首圖放到最後一張
// 更新 uid component 才不會把相同 uid 不同 url 的圖片濾掉
// 找不到合成圖時不動原本的圖片
export const getComposedOrderImages = (images, mapByFirstImageUrl) => {
  const originFirstImageOrder = _.max(_.map(images, 'order')) + 1
  const [firstImage, ...otherImages] = images
  const firstImageUrl = _.get(firstImage, 'url')
  const composedFirstImageUrl = _.get(mapByFirstImageUrl, [`${firstImageUrl}`, 'url'], firstImageUrl)
  if (_.isEqual(composedFirstImageUrl, firstImageUrl)) {
    return images
  }
  return [
    { ...firstImage, url: composedFirstImageUrl, uid: uuidv1() },
    ...otherImages,
    { ...firstImage, order: originFirstImageOrder }
  ]
}

// 取得全部轉換過合成圖的賣場資料
export const getListingsWithComposedImage = (listings, composedImageMapByFirstImageUrl) => {
  const listingsWithComposedImage = _.map(listings, listing => {
    const { models = [] } = listing
    const newModels = _.map(models, model => {
      const modelImages = _.get(model, 'images', [])
      const newModelImages = getComposedOrderImages(modelImages, composedImageMapByFirstImageUrl)
      return { ...model, images: newModelImages }
    })
    return { ...listing, models: newModels }
  })
  return listingsWithComposedImage
}
